import { render, staticRenderFns } from "./VBasket.vue?vue&type=template&id=5ad00a1a&"
import script from "./VBasket.vue?vue&type=script&lang=js&"
export * from "./VBasket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports